var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { k as CustomEvents, J as morph, q as activateInteractionAssets } from "./utilities-Da0sjanJ.js";
class ProductInventoryStatus extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "handleVariantPickerUpdate", (event) => {
      if (event.detail.data.productId !== this.dataset.productId) return;
      let selector = "product-inventory-status";
      if (this.id) {
        selector += `[id="${this.id}"]`;
      } else {
        if (this.dataset.sectionId) selector += `[data-section-id="${this.dataset.sectionId}"]`;
        if (this.dataset.productId) selector += `[data-product-id="${this.dataset.productId}"]`;
        if (this.dataset.blockId) selector += `[data-block-id="${this.dataset.blockId}"]`;
      }
      const newInventoryStatus = event.detail.data.html.querySelector(selector);
      if (newInventoryStatus) {
        morph(this, newInventoryStatus);
        activateInteractionAssets(this);
      }
    });
  }
  connectedCallback() {
    const section = this.closest(".shopify-section");
    if (!section) return;
    section.addEventListener(CustomEvents.variantPickerUpdate, this.handleVariantPickerUpdate);
  }
}
if (!customElements.get("product-inventory-status")) {
  customElements.define("product-inventory-status", ProductInventoryStatus);
}
